export default "__VITE_ASSET__b5d8c99b__"